import axios from "axios";
import { CURR_API } from "@/constants/apis";

/** Shared POST helper for tswebhook.php payloads. */
function postWebhook(body) {
  return axios.post(`${CURR_API}/tswebhook.php`, body, {
    headers: { "Content-Type": "application/json" },
  });
}

function postHelpContent(payload) {
  return postWebhook({ HelpContent: payload });
}

/** Load all help articles + this account's org overrides. */
export async function fetchAllHelpContent(accountnumber) {
  const res = await postHelpContent({
    API_Meth: "GetAllHelpContent",
    accountnumber: accountnumber || "",
  });
  return res.data;
}

/** Save platform article (title/overview/details/howto + role sections). */
export async function upsertHelpArticle(article) {
  const res = await postHelpContent({
    API_Meth: "UpsertHelpArticle",
    help_id: article.help_id,
    title: article.title,
    overview_html: article.overview_html || "",
    details_html: article.details_html || "",
    how_to_html: article.how_to_html || "",
    // Only when the caller says what they are. Sent as `[]` by default, a save
    // that meant nothing about role sections replaced them with none; absent,
    // the API leaves them as they are.
    ...(article.role_sections !== undefined ? { role_sections: article.role_sections } : {}),
  });
  return res.data;
}

/** Save org-specific HTML for one help_id. */
export async function upsertHelpOrgSection(accountnumber, helpId, bodyHtml, updatedBy) {
  const res = await postHelpContent({
    API_Meth: "UpsertHelpOrgSection",
    accountnumber,
    help_id: helpId,
    body_html: bodyHtml || "",
    updated_by: updatedBy || null,
  });
  return res.data;
}

/** accounts.organization (etc.) for the logged-in account number. */
export async function fetchOrganizationSnapshot(accountnumber) {
  const res = await postWebhook({
    Account: {
      API_Meth: "GetOrganizationSnapshot",
      accountnumber: accountnumber || "",
    },
  });
  return res.data;
}
